// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Courses_pageWrapper__bF1+m","title":"Courses_title__OhZA+","CardWrapper":"Courses_CardWrapper__4daR3"};